module.exports = __webpack_public_path__ + "static/media/calendar-color.f7ffb1f7.svg";